const TOKEN_KEY = "fiscalo.portal.token";
const USER_KEY = "fiscalo.portal.user";
const SESSION_EXPIRES_AT_KEY = "fiscalo.portal.sessionExpiresAt";

export interface StoredUser {
  id: string;
  email: string;
  displayName: string | null;
  firstName?: string | null;
  lastName?: string | null;
  profileImage?: string | null;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function getStoredUser(): StoredUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredUser;
    if (
      typeof parsed?.id === "string" &&
      typeof parsed?.email === "string"
    ) {
      return {
        id: parsed.id,
        email: parsed.email,
        displayName:
          parsed.displayName != null ? String(parsed.displayName) : null,
        firstName:
          parsed.firstName != null ? String(parsed.firstName) : null,
        lastName:
          parsed.lastName != null ? String(parsed.lastName) : null,
        profileImage:
          parsed.profileImage != null ? String(parsed.profileImage) : null,
      };
    }
  } catch {
    // ignore
  }
  return null;
}

export function setStoredUser(user: StoredUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearStoredUser(): void {
  localStorage.removeItem(USER_KEY);
}

export function getSessionExpiresAt(): string | null {
  return localStorage.getItem(SESSION_EXPIRES_AT_KEY);
}

export function setSessionExpiresAt(iso: string): void {
  localStorage.setItem(SESSION_EXPIRES_AT_KEY, iso);
}

export function clearSessionExpiresAt(): void {
  localStorage.removeItem(SESSION_EXPIRES_AT_KEY);
}

export function clearAuth(): void {
  clearToken();
  clearStoredUser();
  clearSessionExpiresAt();
}
